import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../../../utils/apidsf";
import swal from "sweetalert";
import RichTextEditor from "react-rte";
import { useDispatch, useSelector } from "react-redux";
import { GetToken } from "../../../../../actions/userAction.js";
import "./CreateLandmark.css";

// components
import FormField from "../../../Components/FormField/FormField";

export default function CreateLandMark() {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  //const [id, setId] = useState("");
  const [textareadata, settextdata] = useState({
    value: RichTextEditor.createEmptyValue(),
  });
  const [formData, setFormData] = useState({
    title: "",
    subTitle: "",
    category: "latest",
    image: "",
    acts: "",
    rawimage: [],
    facts: "",
    Rechtextforfacts: RichTextEditor.createEmptyValue(),
    issues: "",
    Rechtextforissues: RichTextEditor.createEmptyValue(),
    judgement: "",
    Rechtextforjudgement: RichTextEditor.createEmptyValue(),
    held: "",
    Rechtextforheld: RichTextEditor.createEmptyValue(),
    analysis: "",
    Rechtextforanalysis: RichTextEditor.createEmptyValue(),
    court: "",
    judge: "",
    date: "",
    year: "",
  });
  const [filetoken, setfiletoken] = useState("");
  const [show, setshow] = useState(false);

  useEffect(() => {
    dispatch(GetToken());
  }, []);
  useEffect(() => {
    setfiletoken(selector?.adminReducer?.token);
  }, [selector]);

  const handleInputChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    console.log(formData, "// formdata");

    try {
      if (formData?.rawimage?.length !== 0) {
        const form = new FormData();
        form.append("file", formData?.rawimage);
        console.log(formData?.rawimage);
        await fetch("https://assets.thelexpedia.com//wp-json/wp/v2/media", {
          method: "POST",
          headers: {
            Authorization: `Bearer  ${filetoken}`,
          },
          body: form,
        })
          .then((res) => res.json())
          .then(async (data) => {
            const input = {
              profile_image: data.source_url,
            };
            let mainData = {
              title: formData?.title,
              rawimage: formData?.rawimage,
              image: data.source_url,
              facts: formData?.facts,
              Rechtextforfacts: formData?.Rechtextforfacts,
              issues: formData?.issues,
              Rechtextforissues: formData?.Rechtextforissues,
              judgement: formData?.judgement,
              Rechtextforjudgement: formData?.Rechtextforjudgement,
              held: formData?.held,
              Rechtextforheld: formData?.Rechtextforheld,
              analysis: formData?.analysis,
              Rechtextforanalysis: formData?.Rechtextforanalysis,
              court: formData?.court,
              judge: formData?.judge,
              date: formData?.date,
              acts: formData?.acts,
              category: formData?.category,
              subTitle: formData?.subTitle,
              year: formData?.year,
            };

            try {
              let res = null;
              if (id) {
                res = await api.put(
                  `/legal-landmark-admin/${id}`,
                  mainData,
                  config
                );
              } else {
                res = await api.post(
                  "/legal-landmark-admin/",
                  mainData,
                  config
                );
              }
              const data = res.data.data;
              if (data && id) {
                swal({
                  title: "Landmark Updated",
                  text: "Landmark Updated Successfully",
                  icon: "success",
                });
                navigate("/admin/landmark-table");
              } else {
                setFormData({
                  ...formData,
                  rawimage: [],
                  title: "",
                  image: "",
                  facts: "",
                  Rechtextforfacts: RichTextEditor.createEmptyValue(),
                  issues: "",
                  Rechtextforissues: RichTextEditor.createEmptyValue(),
                  judgement: "",
                  Rechtextforjudgement: RichTextEditor.createEmptyValue(),
                  held: "",
                  Rechtextforheld: RichTextEditor.createEmptyValue(),
                  analysis: "",
                  Rechtextforanalysis: RichTextEditor.createEmptyValue(),
                  court: "",
                  judge: "",
                  date: "",
                  acts: "",
                  subTitle: "",
                  category: "latest",
                  year: "",
                });
                swal({
                  title: "Landmark Added",
                  text: "Landmark Added Successfully",
                  icon: "success",
                });
                // show error
              }
            } catch (err) {
              console.error(err.response.data.error);

              swal({
                title: "Error",
                text: err.response.data.error,
                icon: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        try {
          let res = null;
          if (id) {
            res = await api.put(
              `/legal-landmark-admin/${id}`,
              formData,
              config
            );
          } else {
            res = await api.post("/legal-landmark-admin/", formData, config);
          }
          const data = res.data.data;
          if (data) {
            swal({
              title: `Landmark ${id ? "Updated" : "Added"} `,
              text: `Landmark ${id ? "Updated" : "Added"}  Successfully`,
              icon: "success",
            });
          } else {
            // show error
          }
        } catch (err) {
          console.error(err.response.data.error);

          swal({
            title: "Error",
            text: err.response.data.error,
            icon: "error",
          });
        }
      }
    } catch (err) {
      console.error(err.response.data.error);

      swal({
        title: "Error",
        text: err.response.data.error,
        icon: "error",
      });
    }

    // const createOrUpdateLandmark = async () => {
    //   try {
    //     let res = null;
    //     if (id) {
    //       res = await api.put(`/legal-landmark-admin/${id}`, formData, config);
    //     } else {
    //       res = await api.post("/legal-landmark-admin/", formData, config);
    //     }
    //     const data = res.data.data;
    //     if (data) {
    //       // landmark created - redirect to landmark list
    //       navigate("/admin/landmark-table");
    //     } else {
    //       // show error
    //     }
    //   } catch (err) {
    //     console.error(err.response.data.error);
    //     swal({
    //       title: "Error",
    //       text: err.response.data.error,
    //       icon: "error",
    //     });
    //   }
    // };
  };

  useEffect(() => {
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const fetchLandmark = async () => {
      const res = await api.get(`/legal-landmark/${id}`, config);
      const data = res.data.data;
      console.log(data);
      const {
        title,
        image,
        facts,
        court,
        judge,
        date,
        subTitle,
        category,
        acts,
        issues,
        judgement,
        held,
        analysis,
        year,
      } = data;
      setFormData({
        title,
        subTitle,
        category,
        acts,
        facts,
        image,
        date,
        rawimage: [],
        Rechtextforfacts: RichTextEditor.createValueFromString(facts, "html"),
        Rechtextforissues: RichTextEditor.createValueFromString(issues, "html"),
        Rechtextforjudgement: RichTextEditor.createValueFromString(
          judgement,
          "html"
        ),
        Rechtextforheld: RichTextEditor.createValueFromString(held, "html"),
        Rechtextforanalysis: RichTextEditor.createValueFromString(
          analysis,
          "html"
        ),
        court,
        judge,
        year,
      });
    };

    if (id) {
      fetchLandmark();
    } else {
      setFormData({
        ...formData,
        year: "",
        rawimage: [],
        category: "",
        title: "",
        image: "",
        facts: "",
        Rechtextforfacts: RichTextEditor.createEmptyValue(),
        issues: "",
        Rechtextforissues: RichTextEditor.createEmptyValue(),
        judgement: "",
        Rechtextforjudgement: RichTextEditor.createEmptyValue(),
        held: "",
        Rechtextforheld: RichTextEditor.createEmptyValue(),
        analysis: "",
        Rechtextforanalysis: RichTextEditor.createEmptyValue(),
        court: "",
        judge: "",
        date: "",
        acts: "",
        subTitle: "",
      });
    }
  }, [params]);

  const config = {
    readonly: false,
    addNewLineOnDBLClick: false,
  };

  // const handleSetContext = (value) => {
  //   console.log("value: ", value);
  //   setContent(value);
  // };

  const onChangeFacts = (value) => {
    let data = value.toString("html");
    setFormData({
      ...formData,
      facts: data,
      Rechtextforfacts: value,
    });
  };
  const onChangeIssues = (value) => {
    let data = value.toString("html");
    setFormData({
      ...formData,
      issues: data,
      Rechtextforissues: value,
    });
  };
  const onChangeJudgement = (value) => {
    let data = value.toString("html");
    setFormData({
      ...formData,
      judgement: data,
      Rechtextforjudgement: value,
    });
  };
  const onChangeHeld = (value) => {
    let data = value.toString("html");
    setFormData({
      ...formData,
      held: data,
      Rechtextforheld: value,
    });
  };
  const onChangeAnalysis = (value) => {
    let data = value.toString("html");
    setFormData({
      ...formData,
      analysis: data,
      Rechtextforanalysis: value,
    });
  };

  const {
    title,
    subTitle,
    court,
    judge,
    acts,
    category,
    date,
    facts,
    judgement,
    issues,
    year,
    held,
    analysis,
    image,
  } = formData;
  return (
    <div style={{ flex: 4 }}>
      <form action="" className="admin__userUpdateForm" onSubmit={handleSubmit}>
        <div className="userUpdateLeft">
          <FormField
            type="text"
            label="Title"
            placeholder="Title"
            value={title}
            name="title"
            handleChange={handleInputChange}
          />
          <div className="userUpdateItem">
            <label className="user__label">Category</label>
            <select
              value={category}
              name="category"
              onChange={handleInputChange}
            >
              {/* <option value={"select one"}>Select One</option> */}
              <option value={"latest"}>Latest</option>
              <option value={"landmark"}>Landmark</option>
            </select>
          </div>

          <div className="userUpdateItem">
            <label className="user__label">Date</label>
            <input
              type="date"
              placeholder="Date"
              className="userUpdateInput"
              value={formData?.date}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  date: e.target.value,
                });
              }}
            />
          </div>
          {category == "latest" ? (
            <FormField
              type="number"
              label="Year"
              placeholder="Year"
              value={year}
              name="year"
              handleChange={handleInputChange}
            />
          ) : null}

          <div className="userUpdateItem">
            <label className="user__label">Citation</label>
            <textarea
              rows={3}
              style={{ width: "100%" }}
              placeholder="Citation"
              className="userUpdateInput"
              value={formData?.subTitle}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  subTitle: e.target.value,
                });
              }}
            />
          </div>

          <div className="userUpdateItem">
            <label className="user__label">Court Name</label>
            <textarea
              rows={3}
              style={{ width: "100%" }}
              placeholder="Court name"
              className="userUpdateInput"
              value={formData?.court}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  court: e.target.value,
                });
              }}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">Judge</label>
            <textarea
              rows={3}
              style={{ width: "100%" }}
              placeholder="Judge"
              className="userUpdateInput"
              value={formData?.judge}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  judge: e.target.value,
                });
              }}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">Important Provisions / Acts</label>
            <textarea
              rows={3}
              style={{ width: "100%" }}
              placeholder="Important Provisions / Acts"
              className="userUpdateInput"
              value={formData?.acts}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  acts: e.target.value,
                });
              }}
            />
          </div>

          <div className="userUpdateItem">
            <label className="user__label">facts</label>

            <RichTextEditor
              className="desc_area"
              value={formData?.Rechtextforfacts}
              onChange={onChangeFacts}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">issues</label>

            <RichTextEditor
              className="desc_area"
              value={formData?.Rechtextforissues}
              onChange={onChangeIssues}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">judgement</label>

            <RichTextEditor
              className="desc_area"
              value={formData?.Rechtextforjudgement}
              onChange={onChangeJudgement}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">held</label>

            <RichTextEditor
              className="desc_area"
              value={formData?.Rechtextforheld}
              onChange={onChangeHeld}
            />
          </div>
          <div className="userUpdateItem">
            <label className="user__label">analysis</label>

            <RichTextEditor
              className="desc_area"
              value={formData?.Rechtextforanalysis}
              onChange={onChangeAnalysis}
            />
          </div>

          {image == "" ? (
            <>
              <div className="userUpdateItem">
                <label className="user__label">Image Link</label>
                <input
                  type="file"
                  placeholder="Image Link"
                  className="userUpdateInput"
                  // value={formData?.rawimage}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      rawimage: e.target.files[0],
                    });
                  }}
                />
              </div>{" "}
            </>
          ) : (
            <>
              {show ? (
                <>
                  <div className="userUpdateItem">
                    <label className="user__label">Image Link</label>
                    <input
                      type="file"
                      placeholder="Image Link"
                      className="userUpdateInput"
                      //value={formData?.rawimage}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          rawimage: e.target.files[0],
                        });
                      }}
                    />
                  </div>{" "}
                </>
              ) : (
                <>
                  <div className="userUpdateItem">
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <div>
                        <img
                          src={image}
                          style={{
                            height: "140px",
                            width: "400px",
                          }}
                        />
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            setshow(true);
                          }}
                        >
                          Edit{" "}
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </>
              )}
            </>
          )}


          <div>
            <button className="userUpdateButton" type="submit">
              {params.id ? "Update Landmark" : "Add Landmark"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
